import { cn } from "@/lib/utils";
import { Check } from "lucide-react";

interface StepIndicatorProps {
  step: 1 | 2 | 3;
  title: string;
  description: string;
  isActive?: boolean;
  isCompleted?: boolean;
}

export function StepIndicator({
  step,
  title,
  description,
  isActive = false,
  isCompleted = false,
}: StepIndicatorProps) {
  const stepColors = {
    1: "bg-step-1",
    2: "bg-step-2",
    3: "bg-step-3",
  };

  return (
    <div
      className={cn(
        "flex items-start gap-4 p-4 rounded-xl transition-all duration-300 fm-fade-up",
        isActive && "bg-card shadow-sm border border-border"
      )}
    >
      <div
        className={cn(
          "flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-300",
          isCompleted
            ? "bg-success text-success-foreground"
            : isActive
            ? stepColors[step] + " text-white shadow-lg"
            : "bg-muted text-muted-foreground"
        )}
      >
        {isCompleted ? <Check className="w-5 h-5" /> : step}
      </div>
      <div className="flex-1 min-w-0">
        <h3
          className={cn(
            "font-semibold text-base mb-1 transition-colors",
            isActive ? "text-foreground" : "text-muted-foreground"
          )}
        >
          {title}
        </h3>
        <p className="text-sm text-muted-foreground leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
}
